import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { slotTemplateQKeys } from "@hooks/queries/slotTemplate/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface DailyTimeBlock {
  start_time: string;
  end_time: string;
  slot_duration_minutes: number;
  buffer_time_minutes: number;
}

interface UpdateSlotTemplateData {
  name?: string;
  description?: string;
  daily_schedule?: Record<number, DailyTimeBlock[]>;
  recurrence?: {
    type: "daily" | "weekly" | "specific_days";
    days_of_week?: number[];
    start_date: string;
    end_date?: string | null;
  };
  slot_config?: {
    quantity: number;
    default_booked: boolean;
    booking_lead_time_minutes?: number;
  };
  is_active?: boolean;
}

interface MutationProps {
  templateId: string;
  data: UpdateSlotTemplateData;
}

export const useUpdateSlotTemplate = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ templateId, data }: MutationProps) => {
      return api.put(`slot-templates/${templateId}`, data);
    },
    onSuccess: () => {
      showSuccessNotification({ message: "slot-template-updated-success" });
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Update Slot Template]", res);
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
      handleErrors(res, "mutation");
    },
  });
};
